// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3FWiI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1FvWM"};